// AB   TGP-030
// Add empty-paragraph class to empty <p> tags in variant description

document.addEventListener('DOMContentLoaded', () => {
  const variantDescription = document.querySelector('.product__description--variant .product__description--body');
  if (!variantDescription) return;

  // Find all paragraphs in the variant description
  const paragraphs = variantDescription.querySelectorAll('p');
  
  paragraphs.forEach(p => {
    // Check if paragraph is empty (no text content or only whitespace)
    const text = p.textContent.trim();
    if (text === '' || text === '\u00A0') { // Check for empty or &nbsp;
      p.classList.add('empty-paragraph');
    }
  });
});
